import React from 'react';
import { Form, InputGroup } from 'react-bootstrap';

const SelectInput = ({ value, onChange, label, isInvalid, errorMessage, data, isOption = true }) => {
  return (
    <Form.Group className="mb-3">
      {label && <Form.Label className="mb-1">{label}</Form.Label>}
      <InputGroup hasValidation>
        <Form.Select
          value={value || ''}
          onChange={(e) => onChange(e.target.value)}
          isInvalid={isInvalid}
        >
          {isOption && <option value="">Selecionar...</option>}
          {Object.entries(data).map(([key, label]) => (
            <option key={key} value={key}>
              {label}
            </option>
          ))}
        </Form.Select>
        {isInvalid && (
          <Form.Control.Feedback type="invalid">
            {errorMessage}
          </Form.Control.Feedback>
        )}
      </InputGroup>
    </Form.Group>
  );
};

export default SelectInput;